<template>
  <Transition name="info-animation" @enter="handler">
    <div
      v-if="display"
      ref="box"
      class="info-box tw-bg-indigo-50 tw-rounded tw-py-3 tw-px-4"
      :style="{ maxHeight: `${height}px` }"
    >
      <slot />
    </div>
  </Transition>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InfoBox',
  props: {
    display: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      height: 1000,
    }
  },
  methods: {
    handler(el) {
      this.height = el.scrollHeight + 50
    },
  },
})
</script>

<style lang="scss">
.info-animation-enter-active,
.info-animation-leave-active {
  transition: max-height 0.2s linear, padding-bottom 0.2s ease-in, padding-top 0.2s ease-in,
    margin-bottom 0.2s ease-in, margin-top 0.2s ease-in;
  overflow: hidden;
}

.info-animation-enter-from,
.info-animation-leave-to {
  max-height: 0 !important;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}
</style>
